import moment from "moment";

export const addPropertyToArrayOfObjects = (
  array,
  propOldName,
  propNewName
) => {
  let newArray = array.map(function(obj) {
    let tmp = obj;
    if (obj.hasOwnProperty(propOldName)) {
      tmp[propNewName] = obj[propOldName];
    }
    return tmp;
  });
  return newArray;
};

export const formatDate = date => {
  return moment(date).format("DD.MM.YY");
};

export const random = () =>
  Math.random()
    .toString(36)
    .substr(2, 16);
